export namespace ReportDomain {
  // 언젠가 없애버릴 구보고서에만 쓰는 타입
  // BE 측에서도 COMPONENT_SECTIONS 와 구분해서 FE도 구분해서 정의
  export const OLD_COMPONENT_SECTIONS = {
    주별분석: 'WEEKLY',
    단원별분석: 'CHAPTER_SUMMARY',
    난이도별분석: 'LEVEL',
    학습내역: 'STUDY_HISTORY',
    단원별세부페이지: 'CHAPTER_DETAIL',
    영역별분석: 'ASSESSMENT',
  } as const

  export const COMPONENT_SECTIONS = {
    표지: 'COVER',
    월별분석: 'MONTHLY',
    선생님의견: 'COMMENT',
    주별분석: 'WEEKLY',
    단원별분석: 'CHAPTER',
    난이도별분석: 'LEVEL',
    학습내역: 'STUDY_HISTORY',
    학습성과: 'STUDY_PERFORMANCE',
    진단결과: 'SCORING_RESULT',
    학습평가: 'STUDY_EVALUATION',
  } as const

  export const COMPONENT_SECTIONS_KO = {
    COVER: '표지',
    MONTHLY: '월별분석',
    COMMENT: '선생님의견',
    WEEKLY: '주별분석',
    CHAPTER: '단원별분석',
    LEVEL: '난이도별분석',
    STUDY_HISTORY: '학습내역',
    STUDY_PERFORMANCE: '학습성과',
    SCORING_RESULT: '진단결과',
    STUDY_EVALUATION: '학습평가',
  }

  export type OLD_COMPONENT = (typeof OLD_COMPONENT_SECTIONS)[keyof typeof OLD_COMPONENT_SECTIONS]
  export type COMPONENT = (typeof COMPONENT_SECTIONS)[keyof typeof COMPONENT_SECTIONS]
}
